import React from 'react';
import { Box, Typography } from '@mui/material';
import DashboardAnalytics from '../components/dashboard/DashboardAnalytics';

const DashboardPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Tableau de bord
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Vue d&apos;ensemble de la plateforme Sherlook
      </Typography>

      <DashboardAnalytics />
    </Box>
  );
};

export default DashboardPage;
